export const UPCOMING_MOVIES = {
	languages: ['Hindi', 'English', 'Telugu', 'Marathi', 'Tamil', 'Punjabi', 'Kannada', 'Malayalam'],
	cities: [
		'Delhi NCR',
		'Bengaluru',
		'Chennai',
		'Gurgaon',
		'Jaipur',
		'Mumbai',
		'Pune',
		'Hyderabad',
		'Ghaziabad',
		'Noida',
		'Kolkata',
		'Agra',
		'Ahmedabad',
	],
	genres: [
		'Comedy',
		'Horror',
		'Animation',
		'Drama',
		'Fantasy',
		'Action',
		'Thriller',
		'Biography',
		'History',
		'War',
		'Adventure',
		'Sci-fi',
		'Romance',
		'Sports',
		'Crime',
	],
};
